// Specify the Looker DasboardID here
// This are provided by someone from BI
export const LOOKER_DASHBOARDS = {
  carrierPerformance: 'shipstation_analytics_gold::carrier_performance',
  shipmentTracking: 'shipstation_analytics_gold::shipment_tracking',
  profitabilityOptimization: 'shipstation_analytics_gold::shipping_cost',
  orderProcessing: 'shipstation_analytics_gold::order_processing',
  warehouses: 'shipstation_analytics_gold::warehouses',
  returnShipments: 'shipstation_analytics_gold::return_shipments',

  // To be updated in a later PR (see https://auctane.atlassian.net/browse/SPD-25908)
  inventory: 'shipstation::inventory_overview',

  // Dashboards that are not currently used
  shipStationFulfillment: 'shipstation::fulfillment_performance',
  landingPage: 'shipstation::landing_page',
  orderHighlights: 'shipstation::order_highlight',
};

export const LOOKER_EXPLORES = {
  shipments: 'shipstation_analytics_gold::fct_shipments',
  orders: 'shipstation_analytics_gold::fct_orders',
  customers: 'shipstation_analytics_gold::fct_customers', // Not yet available in Looker — will be built by BI
  inventory: 'shipstation_analytics_gold::fct_inventory',
  returns: 'shipstation_analytics_gold::fct_returns',
};

export const EXPLORE_NAV_ITEM_ID = {
  dataExplorer: 'data-explorer',
  exploreShipments: 'explore-shipments',
  exploreOrders: 'explore-orders',
  exploreCustomers: 'explore-customers',
  exploreInventory: 'explore-inventory',
  exploreReturns: 'explore-returns',
};

export const EXPLORE_ROUTE_BY_LOOKER_PATH = {
  'shipstation_analytics_gold/fct_shipments': EXPLORE_NAV_ITEM_ID.exploreShipments,
  'shipstation_analytics_gold/fct_orders': EXPLORE_NAV_ITEM_ID.exploreOrders,
  'shipstation_analytics_gold/fct_customers': EXPLORE_NAV_ITEM_ID.exploreCustomers,
  'shipstation_analytics_gold/fct_inventory': EXPLORE_NAV_ITEM_ID.exploreInventory,
  'shipstation_analytics_gold/fct_returns': EXPLORE_NAV_ITEM_ID.exploreReturns,
};

export const ANALYTICS_NAV_ITEM_ID = {
  shipmentOverview: 'operations',
  carrierPerformance: 'carrier-performance',
  shipmentTracking: 'shipment-tracking',
  profitabilityOptimization: 'profitability-optimization',
  returnShipments: 'return-shipments',
  orderOverview: 'overview',
  orderProcessing: 'order-processing',
  salesAndCustomers: 'sales',
  products: 'products',
  shipStationFulfillment: 'shipstation-fulfillment',
  warehouses: 'warehouses',
  inventory: 'inventory',
  returns: 'returns',
  conversationalAnalytics: 'conversational-analytics',
  reports: 'reports',
};
